enum EcommerceViewModeEnum {
    CARD = "CARD",
    LIST = "LIST",
    QUICK = "QUICK",
}

export default EcommerceViewModeEnum;
